module.exports = __webpack_public_path__ + "img/default.8c91db20.svg";